export default __webpack_public_path__ + "static/media/260px-Headshot.8b484684.png";